import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button, Grid, MenuItem, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { OssDataGridFrame } from "../common/OssDataGridFrame";
import { OssSectionPanel } from "../common/OssPanel";
import { OssLabeledField } from "../common/OssLabeledField";

const emptyForm = {
  itemCode: "",
  itemName: "",
  specification: "",
  unitCode: "EA",
  itemGroupId: "",
  standardLeadDays: "",
  planningBufferDays: "",
};

export const OssItemManager = ({ rows = [], itemGroups = [], loading, onSave }) => {
  const [form, setForm] = useState(emptyForm);
  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  return (
    <OssSectionPanel title="품목 기준">
      <Stack spacing={1.5}>
        <Grid container spacing={1.25}>
          <Grid item xs={6} md={1.4}>
            <OssLabeledField size="small" fullWidth label="품목코드" value={form.itemCode} onChange={(e) => update("itemCode", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={2.2}>
            <OssLabeledField size="small" fullWidth label="품목명" value={form.itemName} onChange={(e) => update("itemName", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={2.2}>
            <OssLabeledField size="small" fullWidth label="규격" value={form.specification} onChange={(e) => update("specification", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={2}>
            <OssLabeledField select size="small" fullWidth label="품목군" value={form.itemGroupId} onChange={(e) => update("itemGroupId", e.target.value)}>
              <MenuItem value="">없음</MenuItem>
              {itemGroups.map((group) => (
                <MenuItem key={group.item_group_id} value={group.item_group_id}>
                  {group.group_name}
                </MenuItem>
              ))}
            </OssLabeledField>
          </Grid>
          <Grid item xs={6} md={1.3}>
            <OssLabeledField size="small" type="number" fullWidth label="소요일" value={form.standardLeadDays} onChange={(e) => update("standardLeadDays", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={1.3}>
            <OssLabeledField size="small" type="number" fullWidth label="계획 여유일" value={form.planningBufferDays} onChange={(e) => update("planningBufferDays", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={1.6}>
            <Button fullWidth variant="contained" startIcon={<AddRoundedIcon />} disabled={loading} onClick={() => onSave(form).then(() => setForm(emptyForm))} sx={{ height: 40 }}>
              추가
            </Button>
          </Grid>
        </Grid>
        <OssDataGridFrame height={360}>
          <DataGrid
            disableRowSelectionOnClick
            rows={rows}
            getRowId={(row) => row.item_id}
            columns={[
              { field: "item_code", headerName: "품목코드", flex: 0.8 },
              { field: "item_name", headerName: "품목명", flex: 1.2 },
              { field: "specification", headerName: "규격", flex: 1.1 },
              { field: "group_name", headerName: "품목군", flex: 0.9 },
              { field: "standard_lead_days", headerName: "소요일", flex: 0.6 },
              { field: "planning_buffer_days", headerName: "계획 여유일", flex: 0.6 },
            ]}
            loading={loading}
            hideFooter={rows.length <= 10}
          />
        </OssDataGridFrame>
      </Stack>
    </OssSectionPanel>
  );
};
